(function() {
    //Key figures placeholders
    let keyFiguresPlaceholders = document.querySelectorAll('.app-site-content-counting-container');
    let keyFiguresPlaceholdersLength = keyFiguresPlaceholders.length;
    //If key figures are detected the rest of the code should load
    if(keyFiguresPlaceholdersLength) {
        /*Function that counts up to entered number as a parameter keyFigureNumber
        and gives the value to the innerHTMl of the HTML element in parameter keyFigureHTML
         */
        function afCountingFunction(placeholder) {
            if(placeholder && placeholder.getBoundingClientRect().top < (window.innerHeight - 100) && placeholder.dataset.countingAssigned === "no") {
                //Giving the info that the placeholder received function
                placeholder.dataset.countingAssigned = "yes";
                const keyFigures = placeholder.querySelectorAll(".app-site-content-counting-tile h2");
                const keyFiguresNumbersLength = keyFigures.length;
                //Multidimensional array where elements are composed of a two length array where first element is the number and the second related HTML element
                const keyFiguresArray = [];
                //Array that contains key figure numbers that is later used to calculate max number
                //var keyFiguresMaxNumber = [];
                if(keyFiguresNumbersLength) {
                    for(let i = 0; i < keyFiguresNumbersLength; i++) {
                        //If condition is there so that counting happens only once and ends when it reaches wanted number
                        if(parseInt(keyFigures[i].dataset.keyfigure) !== parseInt(keyFigures[i].innerHTML)) {
                            keyFiguresArray.push([parseInt(keyFigures[i].dataset.keyfigure),keyFigures[i]]);
                            //keyFiguresMaxNumber.push(parseInt(keyFigures[i].dataset.keyfigure));
                        }
                    }
                    //var maxKeyFigure = Math.max(...keyFiguresMaxNumber);
                    const keyFiguresArrayLength = keyFiguresArray.length;
                    for(let j = 0; j < keyFiguresArrayLength; j++) {
                        const innerKeyFigure = keyFiguresArray[j][0];
                        let counter = 0;
                        let interval = 0;
                        if ( keyFiguresArray[j][0] > 100) {
                            counter = innerKeyFigure - 100;
                            interval = 15;
                        }
                        else {
                            if (innerKeyFigure > 1) {
                                interval = Math.floor(100 / innerKeyFigure) * 15;
                            }
                            else if(innerKeyFigure === 1) {
                                interval = (Math.floor(100 / innerKeyFigure) * 15) / 2;
                            }
                            else {
                                interval = (100 * 15) / 2;
                            }
                        }
                        const intervalId = setInterval(function () {
                            if (counter <= innerKeyFigure - 1) {
                                if (counter > 0) {
                                    keyFiguresArray[j][1].innerHTML = counter;
                                }
                                counter++;
                            }
                            else {
                                clearInterval(intervalId);
                                const finalDec = Math.trunc(Number(keyFiguresArray[j][1].dataset.keyfigure) * 10) / 10;
                                keyFiguresArray[j][1].innerHTML = finalDec.toString().replace(".",",");
                                return false;
                            }
                        }, (interval));
                    }
                }
            }
        }

        //Measuring heights of the headlines
        function afMeasureHeadlineHeights(placeholder) {
            const countingPart = placeholder.querySelectorAll(".app-site-content-counting-tile-headline");
            const countingPartLength = countingPart.length;
            const heights = [];
            if (window.innerHeight > 767) {
                for (let i = 0; i < countingPartLength; i++) {
                    countingPart[i].style.setProperty('height', "");
                }
                for (let i = 0; i < countingPartLength; i++) {
                    heights.push(countingPart[i].offsetHeight);
                }
                const maxHeight = Math.max(...heights);
                for (let i = 0; i < countingPartLength; i++) {
                    countingPart[i].style.height = maxHeight + "px";
                }
            }
            else {
                for (let i = 0; i < countingPartLength; i++) {
                    countingPart[i].style.setProperty('height', "");
                }
            }
        }

        /*
        Assigning functions to the placeholders
        */
        for (let i = 0; i < keyFiguresPlaceholdersLength; i++) {
            (function() {
                const placeholder = keyFiguresPlaceholders[i];
                window.addEventListener("scroll",function(){afCountingFunction(placeholder)});
                window.addEventListener("load",function(){afCountingFunction(placeholder)});
                window.addEventListener("load",function(){afMeasureHeadlineHeights(placeholder)});
                window.addEventListener("resize",function(){afMeasureHeadlineHeights(placeholder)});
            })();
        }
    }
})();
